import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RecordLength, EActionType, EDataTableType } from '../../data/Constants';
import { IPaginationRequest } from '../../../types/IApiTypes';
import { IProductVersionMapping, IProductVersionMappingData } from '../../../types';
import { updateMaintenanceRowData, updateTableData } from '../utilities/SliceDataHelper';
import type { AppState } from '../AppStore';
import { ProductVersionMappingApi } from '../../api/ProductVersionMappingApi';

export const productVersionMappingSliceState: IProductVersionMapping = {
  data: {},
  totalCount: 0,
  currentPage: 1,
  recordsPerPage: RecordLength[0],
  searchKey: '',
};

// This action calls the getProductVersionMapping api method to fetch the product version mappings.
export const getProductVersionMapping = createAsyncThunk(
  'productVersionMapping/getProductVersionMapping',
  async (action: IPaginationRequest, thunkAPI) => {
    return ProductVersionMappingApi.getProductVersionMappingData(action, thunkAPI.dispatch);
  }
);

const ProductVersionMappingSlice = createSlice({
  name: 'productVersionMapping',
  initialState: productVersionMappingSliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductVersionMapping.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        if (action.meta.arg.caller === EActionType.Refresh) {
          updateMaintenanceRowData<IProductVersionMappingData>(
            state.data,
            action.payload.data,
            state.currentPage,
            action.payload.searchKey,
            EDataTableType.ProductVersionMapping
          );
        } else {
          updateTableData(state, action.payload);
        }
      }
    });
  },
});

export const productVersionMapping = (state: AppState) => state.productVersionMapping;

export default ProductVersionMappingSlice.reducer;
